export default "__VITE_ASSET__e7ede401__"